<template lang="pug">
    v-layout(wrap)
        v-flex(xs12)
            m-accordion-content(v-for="item in items" :key="item.name" tabindex="0")
                template(#header="")
                    div {{ item.title }}

                v-card
                    v-card-text(class="pa-0")
                        component(:is="item.component")
</template>

<script>
    import baseAccordionContent from "@mixins/components/modules/accordions/includes/base";

    let name = 'm-accordion-profile-content';
    export default {
        name: name,
        mixins: [baseAccordionContent],
        props: {
            name: {
                type: String,
                default: name
            },
            items: {
                type: Array,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
`
